/**
 * Installs the identify-host request recorder (identify-host-recorder.ts) as
 * `globalThis.__irisIdentifyHostProbe`, only under the IRIS_E2E_TEST gate the
 * other renderer probes use (read through the preload bridge, never bare
 * `process.env`, which Vite replaces with `{}` — see
 * native-preset-submission-probe.ts).
 */
import {
  identifyHostRequests,
  recordIdentifyHostRequest,
  resetIdentifyHostRequests,
  type IdentifyHostProbe
} from './identify-host-recorder.js';

const isE2eEnabled = (): boolean => {
  try {
    return (
      (globalThis as { window?: { electron?: { process?: { env?: Record<string, string> } } } })
        .window?.electron?.process?.env?.IRIS_E2E_TEST === '1'
    );
  } catch {
    return false;
  }
};

if (isE2eEnabled()) {
  const probe: IdentifyHostProbe = {
    record: recordIdentifyHostRequest,
    requests: identifyHostRequests,
    reset: resetIdentifyHostRequests
  };

  (globalThis as { __irisIdentifyHostProbe?: IdentifyHostProbe }).__irisIdentifyHostProbe = probe;
}
